import { IHasDocuments } from "@methods/DocumentMethods";
import { CustomFieldDetailModel } from "@models/customfields/CustomFieldDetailModel";
import { DocumentModel } from "@models/documents/documentmodel";
import { ThirdPartyTermOfNoticePeriodEnum } from "@models/thirdparty/ThirdPartyTermOfNoticePeriodEnum";

export class ThirdPartyContractModel implements IHasDocuments {
    ID: number;
    guid: string;
    ContractNumber: string;
    ContractedValue: number;
    Status: string;
    SignatureDate: Date;
    StartDate: Date;
    EndDate: Date;
    AnnualValue: number;
    Framework: boolean;
    ContractOwner: number;
    currencyCode: string;
    DateModified: Date;

    ThirdPartyGuid: string;

    Documents: DocumentModel[];
    Services: number[] = [];
    CustomFields: CustomFieldDetailModel[] = [];
    TermOfNoticeQuantity: number;
    TermOfNoticePeriod: ThirdPartyTermOfNoticePeriodEnum;
}
